import { Injectable } from '@angular/core';
import { IGeocodingResponse } from '../api/contracts/geocoding.contract';
import { GeocodingApi } from '../api/geocoding.api';
import { OrderLocationGroupContract } from '../models/order-location-group.model';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {
  constructor(private geocodingApi: GeocodingApi) {}

  searchPlaceNames(input: string): Promise<IGeocodingResponse> {
    return this.geocodingApi.searchPlaceNames(input);
  }

  getClosestLocationsByPlace(
    companyDomain: string,
    searchString: string
  ): Promise<OrderLocationGroupContract> {
    return this.geocodingApi.getClosestLocationsByPlace(
      companyDomain,
      searchString
    );
  }

  getClosestLocationsByLatLong(
    companyDomain: string,
    lat: number,
    long: number
  ): Promise<OrderLocationGroupContract> {
    return this.geocodingApi.getClosestLocationsByLatLong(
      companyDomain,
      lat,
      long
    );
  }

  getClosestLocationsByDistance(
    companyDomain: string
  ): Promise<OrderLocationGroupContract> {
    return this.geocodingApi.getClosestLocationsByDistance(companyDomain);
  }
}
